import { AsyncPipe, NgIf } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ConnectionStatus } from '@capacitor/network';
import { BoondockFacade } from '@curbnturf/boondock-listing';
import { Boondock, CARETAKER_TEDDY_ID, HelperFunctions } from '@curbnturf/entities';
import { StatusFacade } from '@curbnturf/status';
import { IonicModule, NavController } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'curbnturf-rating-boondock-start',
  templateUrl: './rating-boondock-start.component.html',
  styleUrls: ['./rating-boondock-start.component.scss'],
  standalone: true,
  imports: [NgIf, AsyncPipe, IonicModule, RouterModule],
})
export class RatingBoondockStartComponent implements OnInit {
  @Output() begin: EventEmitter<void> = new EventEmitter<void>();

  subscriptions: Subscription[] = [];
  boondock$: Observable<Boondock | null>;
  boondock: Boondock | null;
  boondockId: number | undefined;
  networkStatus: ConnectionStatus | undefined;

  getLargePhotoUrl = HelperFunctions.getPhotoUrl;

  get isOnline(): boolean {
    if (this.networkStatus) {
      return !!this.networkStatus?.connected;
    } else {
      return true;
    }
  }

  private appContext: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private navCtrl: NavController,
    private boondockFacade: BoondockFacade,
    private statusFacade: StatusFacade,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.statusFacade.networkStatus$.subscribe((status) => {
        this.networkStatus = status;
      }),
    );

    this.route.data.subscribe((data: { appContext: boolean }) => {
      this.appContext = data.appContext || false;
    });

    this.boondock$ = this.boondockFacade.selected$;
    this.subscriptions.push(
      this.boondock$.subscribe((boondock) => {
        if (boondock) {
          this.boondock = boondock;
          this.boondockId = boondock.id;
        }
      }),
    );
  }

  async onContinue() {
    // Emit event for web and navigate for app.
    if (this.appContext) {
      if (this.boondock?.user?.id === CARETAKER_TEDDY_ID) {
        await this.navCtrl.navigateForward(['rating', 'boondock', this.boondockId, 'caretaker']);
      } else {
        await this.navCtrl.navigateForward(['rating', 'boondock', this.boondockId, 'sections']);
      }
    } else {
      this.begin.emit();
    }
  }
}
